import React from 'react'
import { useTranslation } from 'react-i18next'
import SelectField from './SelectField'
import { COUNTRY_PHONE_PREFIXES } from "../../utils/constants"

const CodePhoneSelect = props => {
    const { t } = useTranslation()
    const selectedPrefix = props.input.value ? COUNTRY_PHONE_PREFIXES[props.input.value] : ''

    // Crear array de países con sus códigos
    const countries = Object.keys(COUNTRY_PHONE_PREFIXES).map(code => ({
        code,
        prefix: COUNTRY_PHONE_PREFIXES[code]
    }))

    // Ordenar países por nombre traducido
    const sortedCountries = [...countries].sort((a, b) => {
        const nameA = t(`countries.${a.code}`) || a.code
        const nameB = t(`countries.${b.code}`) || b.code
        return nameA.localeCompare(nameB)
    })

    return (
        <div className="input-group">
            <SelectField {...props}>
                {sortedCountries.map(country => (
                    <option key={country.code} value={country.code}>
                        {t(`countries.${country.code}`) || country.code}
                    </option>
                ))}
            </SelectField>
            {props.input.value && (
                <span className="input-group-addon">
                    {selectedPrefix}
                </span>
            )}
        </div>
    )
}

export default CodePhoneSelect